import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import NodeList from '@/components/common/Sidebar/NodeList.vue'
import NodeItem from '@/components/common/Sidebar/NodeItem.vue'
import { mapActions, mapGetters } from 'vuex';
import * as types from '@calendar/store/types'
@Component({
    components: { NodeList, NodeItem },
    methods: {
        ...mapActions({
            loadFolder: types.FOLDER_LOAD_TREE,
        })
    },
    computed: {
        ...mapGetters({
            folderList: types.FOLDER_LIST_TREE,
        })
    }
})

export default class CalendarFolderList extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadFolder!: (parentId?: string) => Promise<any>

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    folderList!: any

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    menues: calendar.MenuInfo[] = [
        {
            name: this.$t('일정_조회').toString(),
            id: 'MAIN',
            icon: 'home2',
            select: false,
            expand: true,
            child: [],
            path: 'calendar-main',
            type: 'router-link',
        },
        {
            name: this.$t('W_Schedule_MySchedule').toString(),
            id: 'MY',
            icon: 'box',
            select: false,
            expand: true,
            child: [],
            path: '',
            type: '',
        },
        {
            name: this.$t('W_Schedule_CompanySchedule').toString(),
            id: 'CM',
            icon: 'box',
            select: false,
            expand: true,
            child: [],
            path: '',
            type: '',
        },
        {
            name: this.$t('W_Schedule_DepartSchedule').toString(),
            id: 'DC',
            icon: 'box',
            select: false,
            expand: true,
            child: [],
            path: '',
            type: '',
        },
        // {
        //     name: this.$t('W_Schedule_ScheduleShare').toString(),
        //     id: 'SHARE',
        //     icon: 'box',
        //     select: false,
        //     expand: false,
        //     child: [],
        //     path: '',
        //     type: '',
        // }
    ]

    //
    // ──────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────────
    //

    mounted() {
        const colorArray = [
            '#ff4b09',
            '#ffc609',
            '#e0ff03',
            '#bdff09',
            '#29e1bf',
            '#0942ff',
            '#241eb4',
            '#c609ff',
            '#ff119a',
            '#c9dbdb',
        ]

        this.loadFolder().then(res => {
            var folder = ['MY', 'CM', 'DC']//, 'SHARE']
            var folderList = [
                this.folderList.mylist.items, 
                this.folderList.companylist.items, 
                this.folderList.deptlist.items, 
                //this.folderList.sharedlist.items   
            ]

            folder.forEach((f, index) => {
                var folderChild = this.menues.find(x => x.id == f)?.child
                folderList[index].map((folder: calendar.Folder, index: number) => {
                    var childIndex = this.menues.flatMap(x => x.child).length
                    var folderItem: calendar.MenuInfo = {
                        name: '',
                        id: '',
                        select: false,
                        expand: false,
                        type: '',
                        color: '',
                        folder: null
                    }
                    folderItem.name = folder.displayName
                    folderItem.id = folder.id
                    folderItem.color = !folder.colorCode || folder.colorCode == 'none' ? colorArray[childIndex] : folder.colorCode
                    folderItem.folder = folder
    
                    folderChild?.push(folderItem)
                })
            });
        })
    }
}